module.exports = __webpack_public_path__ + "static/media/swingSideFrame2.ea87d863.png";